import groupBuilderLines from 'lib/cart/groupBuilderLines';
import styles from './builderLineGroups.module.scss';

const BuilderLineGroups = ({ lines, renderLine, headingLevel: Heading = 'h3', idPrefix }) => {
  const entries = groupBuilderLines(lines);
  const orderedLines = entries.flatMap(entry =>
    entry.type === 'line' ? [entry.line] : entry.lines
  );

  return entries.map((entry, position) => {
    if (entry.type === 'line') return renderLine(entry.line, orderedLines.indexOf(entry.line));
    const id = `${idPrefix}-${position}`;
    return (
      <section key={entry.title} aria-labelledby={id} className={styles.builderGroup}>
        <Heading id={id} className={styles.builderGroupTitle}>
          {entry.title}
        </Heading>
        {entry.lines.map((line, lineIndex) => renderLine(line, lineIndex))}
      </section>
    );
  });
};

export default BuilderLineGroups;
